import type { Directive, DirectiveBinding } from "vue";

interface WaterMarkerBinding {
  text: string;
  textColor?: string;
  font?: string;
}

/**
 * 添加背景水印
 <div v-waterMarker="{text:'版权所有',textColor:'rgba(180, 180, 180, 0.4)',font:'16px Microsoft JhengHei'}"></div>
 */

export default {
  mounted(el: HTMLElement, binding: DirectiveBinding<WaterMarkerBinding>) {
    addWaterMarker(binding.value.text, el, binding.value.font, binding.value.textColor);
  },

  updated(el: HTMLElement, binding: DirectiveBinding<WaterMarkerBinding>) {
    // 如果绑定值发生变化，重新添加水印
    addWaterMarker(binding.value.text, el, binding.value.font, binding.value.textColor);
  },
} as Directive;

function addWaterMarker(str: string, parentNode: HTMLElement, font?: string, textColor?: string) {
  // 水印文字，父元素，字体，文字颜色
  const can = document.createElement("canvas");
  parentNode.appendChild(can);
  can.width = 250;
  can.height = 150;
  can.style.display = "none";
  const cans = can.getContext("2d");
  if (cans) {
    cans.rotate((-20 * Math.PI) / 180);
    cans.font = font || "16px Microsoft JhengHei";
    cans.fillStyle = textColor || "rgba(180, 180, 180, 0.3)";
    cans.textAlign = "left";
    cans.textBaseline = "middle";
    cans.fillText(str, can.width / 10, can.height / 2);
    parentNode.style.backgroundImage = `url(${can.toDataURL("image/png")})`;
  }
}
